import { EmployeeBasicModel, MetaPagingModel } from '@shared/models';

export interface ReferralsCountersModel {
  active: { id: number }[];
}

export interface ReferralProgramRefereesResponse {
  referral_program_referees: RefereeModel[];
  meta:                      MetaPagingModel;
}

export interface RefereeModel {
  id:                  number;
  referrer_id:         number;

  salutation?:         string;
  first_name:          string;
  last_name:           string;

  mobile_phone:        string;
  email:               string;

  created_at:          string;
  updated_at?:         string;

  archived_at:         string;
  archived_by:         EmployeeBasicModel;

  referrer:            EmployeeBasicModel;
  hiring_state:        HiringStateEnum;
  jet_identifier:      string;
  referee_verified_at: string;
}

export enum HiringStateEnum {
  SUBMITTED      = 'submitted',
  CONTACTED      = 'contacted',
  CONTACT_POOL   = 'pooled',
  INVITED        = 'invited',
  INTERVIEWED    = 'interviewed',
  PROPOSED       = 'proposed',
  REJECTED       = 'rejected',
  APPROVED       = 'approved',
  DISCHARGED     = 'discharged',
  DELETED        = 'deleted',
  DUPLICATED     = 'duplicated',
}

export function getStatusText(state: HiringStateEnum): string {
  switch (state) {
    case HiringStateEnum.SUBMITTED:    { return 'Eingang';       };
    case HiringStateEnum.CONTACTED:    { return 'Kontakt';       };
    case HiringStateEnum.CONTACT_POOL: { return 'Kontakt Pool';  };
    case HiringStateEnum.INVITED:      { return 'Einladung';     };
    case HiringStateEnum.INTERVIEWED:  { return 'Interview';     };
    case HiringStateEnum.PROPOSED:     { return 'Vorstellung';   };
    case HiringStateEnum.REJECTED:     { return 'Absage';        };
    case HiringStateEnum.APPROVED:     { return 'Mitarbeiter';   };
    case HiringStateEnum.DISCHARGED:   { return 'Ehemaliger';    };
    case HiringStateEnum.DELETED:      { return 'Gelöscht';      };
    case HiringStateEnum.DUPLICATED:   { return 'Duplikat';      };
    default:                           { return 'Unbekannt';     };
  };
}
